import script from "./ExampleTicketTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExampleTicketTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./ExampleTicketTooltip.vue?vue&type=style&index=0&id=2d2d1335&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3760926026/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d2d1335"]])

export default __exports__